import { create } from 'zustand'

export const useFeedModalStore = create((set, get) => ({
  open: false,
  selected: null,
  handleOpen(s) {
    if (!s) return
    set({
      open: true,
      selected: s,
    })
  },

  handleClose() {
    set({
      open: false,
      selected: null,
    })
  },
}))
